import { FILTER_ALL_KEY, FilterOption } from './selection';

export type FilterOptionCounts = Record<string, number>;

/**
 * Add the observation count for each option as its display meta.
 *
 * Location counts may be keyed by name when the summary API does not return a
 * location id, so fall back to the option label.
 */
export const withOptionCounts = (options: FilterOption[], counts: FilterOptionCounts): FilterOption[] =>
  options.map((option) => {
    if (option.key === FILTER_ALL_KEY) return option;

    const count = counts[String(option.key)] ?? counts[option.value];
    return { ...option, meta: typeof count === 'number' ? String(count) : '0' };
  });
